export const environment = {
  production: true,
  version: '1.5.47',
  owsUrl: 'https://ows.otys.nl/jservice.php',
  fileServiceDownload: 'https://appfiles.otysapp.com/fileServiceDownload',
  fileServiceUpload: 'https://ows.otys.nl/fileService.php'
};
